import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import pouchImg from "../../../../assets/imgs/services/nationals/pouch.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";
import "../shared-css/national-global-styles.css";
import "./pouch.css";
import NationalDescription from "../../../../components/national-description/national-description";
import courier3Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier3.svg";
import courier4Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier4.svg";
import condiciones1Icon from "../../../../assets/imgs/services/nationals/gold-icons/Condiciones01.svg";

function Pouch() {
  const [tPouch] = useTranslation("pouchPage");
  const [tSMetaData] = useTranslation("metaData");
  const idPouch = "2128300e-9022-4966-907f-e50f0fad2942";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [openAccordion, setOpenAccordion] = useState(null);
  const nonApplicableIcons = [
    courier3Icon,
    condiciones1Icon,
    courier4Icon,
  ];

  const getListItems = (translationPath) => {
    const list = tPouch(`${translationPath}.items`, { returnObjects: true });

    if (Array.isArray(list) && list.length > 0) {
      return list;
    }

    const legacyItems = [1, 2, 3]
      .map((index) => tPouch(`${translationPath}.item${index}`))
      .filter((item) => item && !item.includes(`${translationPath}.item`));

    return legacyItems;
  };

  const nonApplicableCharges = getListItems("non-applicable-charges");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[10]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[10]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(`${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idPouch}`, {
        headers: {
          Authorization: process.env.REACT_APP_PUBLIC_KEY,
        },
      })
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us[
              "03-Documentation, Acceptance and Delivery"
            ].content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const renderInfoItems = (items, icons) => {
    if (!Array.isArray(items)) return null;

    return items.map((item, index) => (
      <div className="item" key={`${item}-${index}`}>
        <div className="icon">
          <img src={icons[index % icons.length]} alt="" aria-hidden="true" />
        </div>
        <p>{item}</p>
      </div>
    ));
  };

  return (
    <>
      <Helmet>
        <title>{tSMetaData("valija.title")}</title>
        <meta name="description" content={tSMetaData("valija.description")} />
      </Helmet>
      <ImageHeader imgBackground={pouchImg} />
      <div className="info-national-content">
        <NationalDescription
          title={tPouch("header.title")}
          description={textDescription ? JSON.parse(textDescription) : ""}
          contactSales={tPouch("header.contact-sales")}
          contactProductID="btnContactPouch"
        />
        <div className="accordion-content-main">
          <div className="title">
            <h3>{tPouch("header.prepare-charge")}</h3>
          </div>
          <div className="accordion-padd">
            <Accordion
              id={1}
              isOpen={openAccordion === 1}
              onToggle={setOpenAccordion}
              title={tPouch("accordion-1.title")}
              content={accordion1 ? JSON.parse(accordion1) : "{}"}
            />
            <Accordion
              id={2}
              isOpen={openAccordion === 2}
              onToggle={setOpenAccordion}
              title={tPouch("accordion-2.title")}
              content={accordion2 ? JSON.parse(accordion2) : "{}"}
            />
          </div>
        </div>
      </div>
      <div className="more-info-content pouch-more-info">
        <div className="more-info-box">
          <h5>{tPouch("non-applicable-charges.title")}</h5>
          <div className="icons">{renderInfoItems(nonApplicableCharges, nonApplicableIcons)}</div>
        </div>
      </div>
    </>
  );
}

export default Pouch;
